<template>
  <div class="section-wrapper my-classrooms">
    <h2 class="section-title">
      {{ $t("my invitations") }}
      <span class="tag is-rounded">{{ invitations.length }}</span>
    </h2>

    <div
      class="invitationRow"
      v-for="(classroom, index) in invitations"
      :key="`invitation-${index}`"
    >
      <router-link :to="{ name: 'classroom', params: { id: classroom.id } }">
        <div class="title">
          <span class="vcenter">
            <img
              class="tile-img"
              :src="imgsrc(classroom.data.image)"
              v-if="classroom.data && classroom.data.image"
            />
            <DefaultImage v-else />
            {{ classroom.name }}
          </span>
        </div>
      </router-link>

      <span class="invitationActions">
        <van-button
          class="full-height"
          square
          type="primary"
          :text="$t('accept invitation')"
          @click="submitAcceptInvitation(classroom)"
        />
        <van-button
          class="full-height"
          square
          type="danger"
          :text="$t('delete invitation')"
          @click="submitDeleteInvitation(classroom)"
        />
      </span>
    </div>

    <h2 class="section-title">
      {{ $t("my classrooms") }}
      <span class="tag is-rounded">{{ results.length }}</span>
    </h2>
    <van-skeleton title :row="5" v-if="myClassrooms.loading" />
    <Tiles :items="results" tileType="classroom" />
    <van-action-sheet
      v-model="showClassroomDetailsForm"
      :title="formTitle"
      :round="false"
      :cancel-text="$t('cancel')"
    >
      <ClassroomDetailsForm
        v-if="showClassroomDetailsForm"
        :classroom="classroom"
        @closeEdit="closeEdit"
      />
    </van-action-sheet>
    <div style="margin: 16px; display:flex">
      <van-button type="primary" block @click="addNew" v-if="isTeacher">
        {{ $t("add new") }}
      </van-button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import DefaultImage from "@/components/helpers/DefaultImage";
import accountMixin from "@/mixins/accountMixin";
import Tiles from "@/components/Tiles";
import ClassroomDetailsForm from "@/components/classrooms/ClassroomDetailsForm";
export default {
  name: "myClassrooms",
  mixins: [accountMixin],
  components: { DefaultImage, ClassroomDetailsForm, Tiles },
  computed: {
    ...mapState("vokabel", ["myClassrooms", "myInvitations"]),
    ...mapState("account", ["user"]),
    results() {
      const { myClassrooms } = this;
      return myClassrooms.data && myClassrooms.data.results
        ? myClassrooms.data.results
        : [];
    },
    invitations() {
      const { myInvitations } = this;
      return myInvitations.data && myInvitations.data.results
        ? myInvitations.data.results
        : [];
    },
    formTitle() {
      return this.classroom
        ? this.$t("edit classroom")
        : this.$t("new classroom");
    }
  },
  data() {
    return {
      showClassroomDetailsForm: false,
      classroom: null
    };
  },
  methods: {
    ...mapActions("vokabel", [
      "getMyClassrooms",
      "deleteClassroom",
      "getMyInvitations",
      "acceptInvitation",
      "deleteInvitation"
    ]),
    ...mapMutations("setting", ["SET_PAGE_TITLE"]),
    imgsrc(image) {
      let baseStaticHost =
        process.env.NODE_ENV == "development"
          ? ""
          : "https://f002.backblazeb2.com/file/sprkr-user-uploads";

      return image ? `${baseStaticHost}/${image}` : "";
    },
    async submitAcceptInvitation(classroom) {
      try {
        await this.acceptInvitation(classroom.id);
        this.$router.push({ name: "classroom", params: { id: classroom.id } });
      } catch {
        //
      }
    },
    submitDeleteInvitation(classroom) {
      this.deleteInvitation(classroom.id);
    },
    submitDeleteClassroom(classroom) {
      this.deleteClassroom(classroom.id);
    },
    isAdmin(classroom) {
      return classroom.admins.includes(this.user.id) ? true : false;
    },
    addNew() {
      this.showClassroomDetailsForm = true;
      this.classroom = null;
    },
    // editClassroom(classroom) {
    //   this.showClassroomDetailsForm = true;
    //   this.classroom = classroom;
    // },
    closeEdit() {
      this.showClassroomDetailsForm = false;
    }
  },
  mounted() {
    this.SET_PAGE_TITLE(this.$t("classrooms"));
    this.getMyClassrooms();
    this.getMyInvitations();
  }
};
</script>
<style lang="scss">
.invitationRow {
  display: flex;
  justify-content: space-between;
  margin: 6px 18px;
}
</style>
